import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import Icon from 'uikit/Icon';

import styles from './ContributeCard.module.scss';

const cx = classNames.bind(styles);

const ContributeCard = ({ t }) => (
  <div className={cx('container')}>
    <div className={cx('icon')}>
      <Icon name="sad-tear" />
    </div>
    <div className={cx('text')}>
      <p className={cx('title')}>
        {t(
          'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/ContributeCard/title',
        )}
      </p>
      <p className={cx('subtitle')}>
        {t(
          'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/ContributeCard/subtitle',
        )}
      </p>
    </div>
    <Button
      as="a"
      href={t(
        'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/ContributeCard/helpdesk-link',
      )}
      intent="primary"
    >
      {t(
        'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/ContributeCard/contribute',
      )}
    </Button>
  </div>
);

ContributeCard.propTypes = {
  t: PropTypes.func.isRequired,
};

export default ContributeCard;
